import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { SurveysBySpecialistRow } from '../surveys-by-specialist-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<SurveysBySpecialistRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.accSessionSpecialistSurveyResponseId, { header: 'accSessionSpecialistSurveyResponseId' }),
		buildColumn(util, 'Id', row => row.accSessionAttendeeId, { header: 'accSessionAttendeeId' }),
		buildColumn(util, 'Id', row => row.specialistPersonId, { header: 'specialistPersonId' }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'topicId' }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Id', row => row.entrepreneurPersonId, { header: 'entrepreneurPersonId' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.event.startUTC), { header: 'Session', hidden: true }),
		buildColumn(util, 'Text', row => row.event.venue || 'Online', { header: 'Venue', hidden: true }),
		buildColumn(util, 'Text', row => row.topicNames, { header: 'Session Topics', hidden: true }),
		buildColumn(util, 'Text', row => row.topic, {
			header: 'Topic', hidden: true, group: {
				dir: 'asc',
				order: 2
			}
		}),
		buildColumn(util, 'Text', row => row.specialistName, {
			header: 'Specialist', hidden: true, group: {
				dir: 'asc',
				order: 1
			}
		}),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture', hidden: true }),
		buildColumn(util, 'Text', row => row.entrepreneurName, { header: 'Entrepreneur', sort: 'asc', width: 200 }),
		buildColumn(util, 'Text', row => row.professionalismBucket, { header: 'Professionalism', headerTooltip: 'Professionalism: "The specialist was professional."' }),
		buildColumn(util, 'Number', row => row.specialistSurveyProfessionalismScore, { header: 'Professionalism Rating', headerTooltip: 'Professionalism: "TThe specialist was professional. (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.knowledgeBucket, { header: 'Knowledge', headerTooltip: 'Knowledge: "The specialist was knowledgeable about this topic."' }),
		buildColumn(util, 'Number', row => row.specialistSurveyKnowledgeScore, { header: 'Knowledge Rating', headerTooltip: 'Knowledge: "The specialist was knowledgeable about this topic. (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.effectivenessBucket, { header: 'Effectiveness', headerTooltip: 'Effectiveness: "The specialist effectively taught the topic."' }),
		buildColumn(util, 'Number', row => row.specialistSurveyEffectivenessScore, { header: 'Effectiveness Rating', headerTooltip: 'Effectiveness: "The specialist effectively taught the topic. (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.other, { header: 'Comment', headerTooltip: 'Other Feedback (optional)', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created', hidden: true }),

	];


	return columns;

}